import React from 'react';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import StoreList from './StoreList';
import NoResults from './NoResults';
import ViewAllTrigger from './ViewAllTrigger';
import { calculateRoute } from '../../../helper';
import defaultClasses from './searchResults.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';
var INIT_AVAILABLE_STORE_LOCATION_COUNT = 10;

var SearchResults = function SearchResults(props) {
  var coordinates = props.coordinates,
      showMarker = props.showMarker,
      storesNearby = props.storesNearby,
      shownStores = props.shownStores,
      setShownStores = props.setShownStores,
      viewAll = props.viewAll,
      toggle = props.toggle,
      setNewPosition = props.setNewPosition,
      predefinedCoordinates = props.predefinedCoordinates,
      onGetDirection = props.onGetDirection,
      geoError = props.geoError,
      scrollToMap = props.scrollToMap,
      showSearchResults = props.showSearchResults,
      showResetSearch = props.showResetSearch,
      resetSearch = props.resetSearch;
  var classes = useStyle(defaultClasses, props.classes);

  if (!showSearchResults) {
    return React.createElement(React.Fragment, null);
  }

  var resetSearchFn = function resetSearchFn() {
    return resetSearch();
  };

  return React.createElement("div", {
    className: "".concat(classes.root)
  }, showMarker && React.createElement(React.Fragment, null, React.createElement("p", {
    className: "mt-5 md_mt-[1.5rem] mb-4 md_mb-0 flex justify-between flex-wrap"
  }, React.createElement("div", null, React.createElement("span", {
    className: "mr-2.5"
  }, "Search Results:"), ' ', React.createElement("span", {
    className: defaultClasses.searchResults
  }, "(", storesNearby.length, " Result", storesNearby.length === 1 ? '' : 's', ")")), showResetSearch && React.createElement("p", {
    className: "".concat(classes.resetSearch, " cursor-pointer my-2 underline"),
    onClick: resetSearchFn
  }, "Reset Search")), !isUndefined(storesNearby) && !isEmpty(storesNearby) ? React.createElement(React.Fragment, null, React.createElement(StoreList, {
    onGetDirection: onGetDirection,
    predefinedCoordinates: predefinedCoordinates,
    storesNearby: storesNearby,
    viewAll: viewAll,
    shownStores: shownStores,
    setShownStores: setShownStores,
    setNewPosition: setNewPosition,
    calculateRoute: calculateRoute,
    coordinates: coordinates,
    initAvailableStoreLocationCount: INIT_AVAILABLE_STORE_LOCATION_COUNT // e_commerce={e_commerce}

  }), (storesNearby === null || storesNearby === void 0 ? void 0 : storesNearby.length) > INIT_AVAILABLE_STORE_LOCATION_COUNT ? React.createElement(ViewAllTrigger, {
    viewAll: viewAll,
    toggle: toggle
  }) : React.createElement(React.Fragment, null)) : React.createElement(React.Fragment, null)), (geoError || showMarker && !(!isUndefined(storesNearby) && !isEmpty(storesNearby))) && React.createElement(NoResults, {
    geoError: geoError
  }));
};

export default SearchResults;